import { Component, computed, inject, input } from '@angular/core'
import { Location, NgOptimizedImage } from '@angular/common'

import { RouteHeader } from '@core/navigation'
import { AppStore } from '@core/store'
import { Icon } from '@shared/ui'

/** Encabezado de sección: título, descripción e ilustración de la ruta activa. */
@Component({
  selector: 'section-header',
  imports: [NgOptimizedImage, Icon],
  templateUrl: './section-header.html'
})
export class SectionHeader {
  readonly #location = inject(Location)

  readonly #user = inject(AppStore).currentUser

  readonly header = input.required<RouteHeader>()

  protected readonly description = computed(() => {
    const { description, descriptionByRole } = this.header()
    const role = this.#user()?.role

    return (role && descriptionByRole?.[role]) || description
  })

  protected back(): void {
    this.#location.back()
  }
}
